class ModuleFlatpickr {
    constructor(template) {
        this.template = template;
        this.init();
    }
    /**
     * สร้าง instance ของ flatpickr
     * @param {string} element - ชื่อ element ที่จะใช้งาน flatpickr
     * @author เต้ย
     */
    init() {
        const self = this;

        $('.flatpickr-date-input').each(function () {
            let input = $(this);
            let picker = self.initDateRange(this);

            // Store a reference to the flatpickr instance with the input element for later retrieval
            input.data('flatpickrInstance', picker);
        });

        // Handle clear buttons globally, fetch flatpickr instance by input for each clear event
        $(document).on('click', '.btn-range-clear', function (e) {
            // Try to find the closest .flatpickr-date-input associated with this button
            // Assumes button is near the input -- adjust selector as appropriate for your DOM
            let inputs = $(this).closest('form, .input-group, .flatpickr-container').find('.flatpickr-date-input');
            if (inputs.length === 0) {
                // fallback: try global search if not found in scope
                inputs = $('.flatpickr-date-input').first();
            }

            inputs.each(function () {
                let input = $(this);
                let picker = input.data('flatpickrInstance');
                if (picker && typeof picker.clear === 'function') {
                    picker.clear();
                } else {
                    input.val('');
                }
            });
        });
    }
    /**
     * สร้าง instance ของ flatpickr
     * @param {string} element - ชื่อ element ที่จะใช้งาน flatpickr
     * @author เต้ย
     */
    initDateRange(element) {
        const defaultDate = $(element).attr('data-default-date');
        const textlang = 'th';

        // Config พื้นฐาน
        const baseConfig = {
            dateFormat: 'Y-m-d', // รูปแบบที่จะเก็บค่าจริง (ค.ศ.)
            altInput: true, // ใช้ input แสดงผลอีกช่องหนึ่ง
            altFormat: 'j M Y', // รูปแบบที่แสดง
            defaultDate: defaultDate ? defaultDate : undefined, // กำหนดวันที่เริ่มต้น
        };

        // ถ้าเป็นภาษาไทย ให้เพิ่ม config สำหรับ พ.ศ.
        if (textlang === 'th') {
            return flatpickr(element, {
                ...baseConfig,
                locale: 'th', // กำหนดให้ใช้ภาษาไทย
                formatDate: function (date, format, locale) {
                    // ถ้าเป็น altFormat ให้แสดงเป็น พ.ศ.
                    // ถ้าเป็น dateFormat ให้ใช้ ค.ศ. เสมอ
                    if (format === baseConfig.altFormat) {
                        // สำหรับการแสดงผล (altFormat) ให้ใช้ พ.ศ.
                        let formattedDate = flatpickr.formatDate(date, format, locale);
                        const yearInCE = date.getFullYear(); // ปี ค.ศ.
                        const yearInBE = yearInCE + 543; // แปลงเป็นปี พ.ศ.
                        formattedDate = formattedDate.replace(new RegExp('\\b' + yearInCE + '\\b', 'g'), yearInBE);
                        return formattedDate;
                    } else {
                        // สำหรับ value (dateFormat) ให้ใช้ ค.ศ. เสมอ
                        return flatpickr.formatDate(date, format, locale);
                    }
                },
                onMonthChange: function (selectedDates, dateStr, instance) {
                    // อัปเดตหัวปฏิทินให้แสดงปี พ.ศ.
                    setTimeout(() => {
                        if (!instance.calendarContainer) return;
                        const yearInput = instance.calendarContainer.querySelector(
                            '.flatpickr-current-month input.cur-year',
                        );
                        if (yearInput && yearInput.value && !isNaN(yearInput.value)) {
                            const year = parseInt(yearInput.value);
                            if (year >= 1900 && year <= 2100) {
                                // ถ้าเป็น ค.ศ. ในช่วงที่สมเหตุสมผล
                                yearInput.value = year + 543;
                            }
                        }
                    }, 50);
                },
                onYearChange: function (selectedDates, dateStr, instance) {
                    // อัปเดตหัวปฏิทินให้แสดงปี พ.ศ. เมื่อเปลี่ยนปี
                    setTimeout(() => {
                        if (!instance.calendarContainer) return;
                        const yearInput = instance.calendarContainer.querySelector(
                            '.flatpickr-current-month input.cur-year',
                        );
                        if (yearInput && yearInput.value && !isNaN(yearInput.value)) {
                            const year = parseInt(yearInput.value);
                            if (year >= 1900 && year <= 2100) {
                                // ถ้าเป็น ค.ศ. ในช่วงที่สมเหตุสมผล
                                yearInput.value = year + 543;
                            }
                        }
                    }, 50);
                },
                onReady: function (selectedDates, dateStr, instance) {
                    // อัปเดตหัวปฏิทินให้แสดงปี พ.ศ. เมื่อเริ่มต้น
                    setTimeout(() => {
                        if (!instance.calendarContainer) return;
                        const yearInput = instance.calendarContainer.querySelector(
                            '.flatpickr-current-month input.cur-year',
                        );
                        if (yearInput && yearInput.value && !isNaN(yearInput.value)) {
                            const year = parseInt(yearInput.value);
                            if (year >= 1900 && year <= 2100) {
                                // ถ้าเป็น ค.ศ. ในช่วงที่สมเหตุสมผล
                                yearInput.value = year + 543;
                            }
                        }
                    }, 100);
                },
                onOpen: function (selectedDates, dateStr, instance) {
                    // อัปเดตหัวปฏิทินให้แสดงปี พ.ศ. ทุกครั้งที่เปิดปฏิทิน
                    setTimeout(() => {
                        if (!instance.calendarContainer) return;
                        const yearInput = instance.calendarContainer.querySelector(
                            '.flatpickr-current-month input.cur-year',
                        );
                        if (yearInput && yearInput.value && !isNaN(yearInput.value)) {
                            const year = parseInt(yearInput.value);
                            if (year >= 1900 && year <= 2100) {
                                // ถ้าเป็น ค.ศ. ในช่วงที่สมเหตุสมผล
                                yearInput.value = year + 543;
                            }
                        }
                    }, 50);
                },
            });
        } else {
            // ถ้าไม่ใช่ภาษาไทย ให้ใช้ config ปกติ (ค.ศ.)
            return flatpickr(element, baseConfig);
        }
    }

    /**
     * สร้าง instance ของ flatpickr แบบเลือกวันและเวลา
     * ใช้ตัวแปลงปี พ.ศ. ชุดเดียวกับ initDateRange ไม่ได้ทำปฏิทินขึ้นมาใหม่
     * @param {string|Element} element - element ที่จะผูกปฏิทิน
     * @param {object} options - ทับ config ได้ เช่น minDate หรือ defaultDate
     * @author เต้ย
     */
    initDateTime(element, options = {}) {
        const baseConfig = {
            enableTime: true,
            time_24hr: true,
            minuteIncrement: 5,
            dateFormat: 'Y-m-d H:i',
            altInput: true,
            altFormat: 'j M Y H:i',
            ...options,
        };

        return flatpickr(element, {
            ...baseConfig,
            locale: 'th',
            formatDate: (date, format, locale) => {
                if (format === baseConfig.altFormat) {
                    const yearInCE = date.getFullYear();
                    return flatpickr
                        .formatDate(date, format, locale)
                        .replace(new RegExp('\\b' + yearInCE + '\\b', 'g'), yearInCE + 543);
                }
                return flatpickr.formatDate(date, format, locale);
            },
            onMonthChange: (selectedDates, dateStr, instance) => {
                setTimeout(() => {
                    if (!instance.calendarContainer) return;
                    const yearInput = instance.calendarContainer.querySelector(
                        '.flatpickr-current-month input.cur-year',
                    );
                    if (yearInput && yearInput.value && !isNaN(yearInput.value)) {
                        const year = parseInt(yearInput.value);
                        if (year >= 1900 && year <= 2100) {
                            yearInput.value = year + 543;
                        }
                    }
                }, 50);
            },
        });
    }
}
